<template>
  <button
    type="button"
    class="inline-flex items-center justify-center rounded-sm border border-white/75 px-[3px] py-[2px] text-[11px] leading-[12px] font-medium tracking-[-0.073px] text-white shadow-[0_4px_8px_rgba(0,0,0,0.05),0_1px_2px_rgba(0,0,0,0.05)]"
    :class="[levelClass, clickableClass]"
    @click.stop="emit('click')"
  >
    {{ label }}
  </button>
</template>

<script setup lang="ts">
import { ScoreLevel } from '@/shared/graphql/router/graphql'
import { formatNumber } from '@/shared/utils/number'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    id: string | number
    level?: ScoreLevel | null
    clickable?: boolean
  }>(),
  { clickable: false }
)

const emit = defineEmits<{
  click: []
}>()

const label = computed(() => {
  if (typeof props.id === 'number') return formatNumber(props.id)

  return /^-?(?:0|[1-9]\d*)(?:\.\d+)?$/.test(props.id)
    ? formatNumber(props.id)
    : props.id
})

const clickableClass = computed(() => ({
  'cursor-pointer': props.clickable,
}))

const levelClass = computed(() => ({
  'bg-gray-500': !props.level,
  'bg-red-500': props.level === ScoreLevel.High,
  'bg-yellow-500': props.level === ScoreLevel.Medium,
  'bg-green-500': props.level === ScoreLevel.Low,
}))
</script>
